

const GetEStatusName = (id) => {
    switch (id) {
        case 0: { return "Blocked" }
        case 1: { return "Active" }
        case 2: { return "Deactive" }
    }

}

const GetEStatus = {
    EStatus: [
        { Id: 0, Name: "Blocked" },
        { Id: 1, Name: "Active" },
        { Id: 2, Name: "Deactive" }

    ]
}

const GetEStatusByDrUser = {
    EStatus: [
        { Id: 1, Name: "Active" },
        { Id: 2, Name: "Deactive" }

    ]
}
export { GetEStatusName, GetEStatus, GetEStatusByDrUser }